import React, {useEffect} from "react";
import {useSelector} from "react-redux";
import {dashboardSelector} from "./selector";
import {loadDashboardForEmployer} from "./action";
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";
import Loader from "../common/Loader";
import Header from "../common/Header";
import Sidebar from "../common/Sidebar";
import Footer from "../common/Footer";
import Card from "./card";
import useConfiguration from "../../hooks/useConfiguration";
import useSessionStorage from "../../hooks/useSessionStorage";
import DataGrid from "../common/DataGrid";

import {
    updateSort,
    loadShiftsCoverageListings
} from "../ShiftsCoverage/action";
import { createHeaders, createPageData } from "../ShiftsCoverage/shiftsCoverageUtilities";
import { shiftsCoverageSelector } from '../ShiftsCoverage/selector';

export default () => {

    
    const headers = createHeaders();
    const { data, pageSize, page } = useSelector(shiftsCoverageSelector);

    const dispatch = useDispatch();
    const config = useConfiguration();
    const storage = useSessionStorage();
    const navigate = useNavigate();
    const login = storage.getItem("login");
    const {dashboarddata} = useSelector(dashboardSelector);
    const EmployerDashboardapprovedCandidateds = dashboarddata.approvedCandidateds || []
    const EmployerDashboardfutureJobs = dashboarddata.futureJobs || []
    const EmployerDashboardtodayActiveJobs = dashboarddata.todayActiveJobs || []
    //console.log(dashboarddata)
  //  const EmployerDashboard = data.abc || []
    //console.log(dashboarddata.profileInfo.countValue);
    //console.log(EmployerDashboard);

    const empId = login.employerUniqueId;
    const url = config.baseUrl;

    const profileSubmitted = dashboarddata.profileFlag && dashboarddata.profileFlag.isProfileSubmitted;
    useEffect(() => {
        document.title = "Overture Dashboard";
        if (config.baseUrl) {
            if (!login) {
                navigate("/");
            } else {
              //  dispatch(loadDashboard(config.baseUrl, login.candidateId));
                dispatch(loadDashboardForEmployer(config.baseUrl, login.employerUniqueId));
                dispatch(loadShiftsCoverageListings({ url, empId }));
            }
        }

    }, [config]);

    
    const editProfile = (event) => {
        event.preventDefault();
        navigate("/profile");
    };
    const generateRowData = (data, headers) => {
        const rowData = {};
        headers.forEach(header => {
            if (header.type === 'text') {
                if (typeof header.field === 'array') {
                    rowData[header.name] = header.field.map(fld => data[fld]).join(" ");
                } else {
                    rowData[header.name] = data[header.field]
                }
            } else {
                if (header.field === 'isClaimed') {
                    const isClaimed = data[header.field];
                    const iconClass = isClaimed ? 'green-icon' : 'grey-icon'
                    rowData[header.name] = {
                        type: 'icon',
                        class: `fa fa-check-circle icon-align ${iconClass}`
                    }
                }
                if (header.field === 'isCheckedIn') {
                    const isCheckedIn = data[header.field];
                    const iconClass = isCheckedIn ? 'fa-check-circle green-icon' : 'fa-times-circle red-icon'
                    rowData[header.name] = {
                        type: 'icon',
                        class: `fa icon-align ${iconClass}`
                    }
                }
                if (header.field === 'isCheckedOut') {
                    const isCheckedOut = data[header.field];
                    const iconClass = isCheckedOut ? 'fa-check-circle green-icon' : 'fa-times-circle red-icon'
                    rowData[header.name] = {
                        type: 'icon',
                        class: `fa icon-align ${iconClass}`
                    }
                }
                if (header.field === 'isPaid') {
                    const isPaid = data[header.field];
                    const iconClass = isPaid ? 'green-icon fa-check-circle' : 'fa-times-circle red-icon'
                    rowData[header.name] = {
                        type: 'icon',
                        class: `fa icon-align ${iconClass}`
                    }
                }
               

                if (header.field === 'ratings') {
                    rowData[header.name] = {
                        type: 'ratings',
                        value: data[header.field]
                    }
                }
                if (header.name === 'Approval') {
                    rowData[header.name] = data[header.field]?.map(fld => {
                        const isSuccess = data[fld];
                        const iconClass = isSuccess ? 'green-icon fa-check-circle' : 'fa-times-circle red-icon'
                        return {
                            type: 'icon',
                            class: `fa icon-align ${iconClass}`
                        }
                    });
                }
                
            }
        });
        return rowData;
    }
    const formatTableData = (data) => {
        const tableData = {
            headers,
            rows: data?.jobShifts?.map(data => ({
                columns: generateRowData(data, headers)
            })),
            options: {
                sortable: false,
                filter: false,
                pagination: false,
                pageSize: pageSize || 10
            },
            pageData: createPageData(page, pageSize, data?.totalCount),
           
            headerComponentParams: {
                sort: (order, column) => {
                    dispatch(updateSort(order, column)).then(() => {
                        dispatch(loadShiftsCoverageListings({ url, empId }));
                    });
                },
                headers
            }
        }
        return tableData;
    }
    return (
        <div className="page">
            <Loader/>
            <Header/>
            <Sidebar/>
            <div className="page-main">
                <div className="main-content app-content mt-0 main-background">
                    <div className="side-app">
                        <div className="main-container container-fluid">
                            <div className="page-header">
                                <h1 className="page-title">Employer Dashboard</h1>
                                <div>
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><a href="javascript:void(0)">Dashboard</a></li>
                                    </ol>
                                </div>
                            </div>                            
                                   <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xl-12">
            <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12 col-xl-3">
                    <div class="card overflow-hidden">
                        <div class="card-body">
                            <div class="d-flex">
                                <div class="md-4">
                                    <h6 style={{ fontSize:'1.125rem',fontWeight: 'bold' }}>Approved Candidates</h6>
                                    <h2 class="mb-0 number-font" style={{ color:'Green' }}>{EmployerDashboardapprovedCandidateds.countValue}</h2>
                                </div>                               
                            </div>                           
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xl-3">
                    <div class="card overflow-hidden">
                        <div class="card-body">
                            <div class="d-flex">
                                <div class="md-4">
                                    <h6 style={{ fontSize:'1.125rem',fontWeight: 'bold' }}>Today’s Active shifts</h6>
                                      <h2 class="mb-0 number-font" style={{ color:'#f404f4' }}>{EmployerDashboardtodayActiveJobs.countValue}</h2>  
                                </div>                               
                            </div>                           
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xl-3">
                    <div class="card overflow-hidden">
                        <div class="card-body">
                            <div class="d-flex">
                                <div class="md-4">
                                    <h6 style={{ fontSize:'1.125rem',fontWeight: 'bold' }}>Future shifts</h6>
                                    <h2 class="mb-0 number-font" style={{ color:'blueviolet' }}>{EmployerDashboardfutureJobs.countValue}</h2> 
                                </div>                               
                            </div>                           
                        </div>
                    </div>
                </div>
                {/* <div class="col-lg-6 col-md-6 col-sm-12 col-xl-3">
                    <div class="card overflow-hidden">
                        <div class="card-body">
                            <div class="d-flex">
                                <div class="md-6">
                                    <h6 style={{ fontSize:'1.125rem',fontWeight: 'bold' }}>Today's Active Jobs</h6>
                                     <h2 class="mb-0 number-font" style={{ color:'blueviolet' }}>{data.TodayActiveJobs.countValue}</h2>
                                </div>                               
                            </div>                           
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xl-3">
                    <div class="card overflow-hidden">
                        <div class="card-body">
                            <div class="d-flex">
                                <div class="md-6">
                                    <h6 style={{ fontSize:'1.125rem',fontWeight: 'bold' }}>Approved Candidates</h6>
                                     <h2 class="mb-0 number-font" style={{ color:'blueviolet' }}>{data.FutureJobs.countValue}</h2>
                                </div>                               
                            </div>                           
                        </div>
                    </div>
                </div>                 */}
            </div>
            <div class="row">
            <div className="row">
                            <div className="col-xl-12 col-md-12 col-lg-12">
                                <div className="card">
                                    <div className="card-body">
                                        <DataGrid {...formatTableData(data)} />
                                    </div>
                                </div>
                            </div>
                        </div>
                
            </div>
        </div>
    </div>
                            
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    );
};
